import { createNameContext } from '@showroomjs/ui';
import { isPlainObject, noop } from '@showroomjs/core';
import * as React from 'react';
export const ConsoleContext = createNameContext('PreviewConsole', Object.assign({}, console, { fatal: console.error }));
const ConsoleMessageContext = createNameContext('ConsoleMessage', []);
export const PreviewConsoleProvider = (props) => {
    const [msgs, setMsgs] = React.useState([]);
    const isMountedRef = React.useRef(true);
    React.useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const previewContext = React.useMemo(() => {
        const addMessage = (level, ...msgs) => {
            if (!isMountedRef.current) {
                return;
            }
            setMsgs((oldMsgs) => {
                const lastMessage = oldMsgs[oldMsgs.length - 1];
                if (lastMessage &&
                    lastMessage.level === level &&
                    deepEqual(lastMessage.data, msgs)) {
                    return oldMsgs.map((msg, index) => index === oldMsgs.length - 1
                        ? Object.assign(Object.assign({}, msg), { count: msg.count + 1 }) : msg);
                }
                return oldMsgs.concat({
                    level: level,
                    data: msgs,
                    count: 1,
                });
            });
        };
        return Object.assign({}, console, {
            log: addMessage.bind(null, 'log'),
            error: addMessage.bind(null, 'error'),
            fatal: addMessage.bind(null, 'fatal'),
            warn: addMessage.bind(null, 'warn'),
            info: addMessage.bind(null, 'info'),
        });
    }, []);
    return (React.createElement(ConsoleContext.Provider, { value: previewContext },
        React.createElement(ConsoleMessageContext.Provider, { value: msgs }, props.children)));
};
export const useConsole = () => React.useContext(ConsoleContext);
export const noopConsole = {
    log: noop,
    error: noop,
    warn: noop,
    info: noop,
};
export const useConsoleMessage = () => React.useContext(ConsoleMessageContext);
const oKeys = Object.keys;
// https://stackoverflow.com/a/32922084/1866804
const deepEqual = (x, y) => {
    if (Array.isArray(x)) {
        return Array.isArray(y) && x.every((item, i) => deepEqual(item, y[i]));
    }
    const tx = typeof x;
    const ty = typeof y;
    return x && y && tx === 'object' && tx === ty && isPlainObject(x)
        ? oKeys(x).length === oKeys(y).length &&
            oKeys(x).every((key) => deepEqual(x[key], y[key]))
        : x === y;
};
//# sourceMappingURL=use-preview-console.js.map